import { useQuery } from '@hooks/reactQuery';

import { getPortalMilestonesGroupedTasksToLink } from '@api/portalMilestones';

import { extractQueryParams } from '@utils/common';

import { IPortalGroupedTasksToLinkDTO } from '@interfaces/portal/dto/taskManagementDTO';

import { EUserRoles } from '@enums/common';

import { GET_PORTAL_MILESTONES_GROUPED_TASKS_TO_LINK } from '@constants/queryKeys';

interface IUseQueryPortalMilestonesTasksToLinkReturned {
	isLoadingPortalMilestonesGroupedTasksToLink: boolean;
	portalMilestonesGroupedTasksToLink: IPortalGroupedTasksToLinkDTO[];
}

interface IUseQueryPortalMilestonesTasksToLink {
	milestoneId?: string | null;
	projectId?: string;
}

export const useQueryPortalMilestonesGroupedTasksToLink = ({
	milestoneId,
	projectId,
}: IUseQueryPortalMilestonesTasksToLink): IUseQueryPortalMilestonesTasksToLinkReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<IPortalGroupedTasksToLinkDTO[]>({
			queryKey: [
				GET_PORTAL_MILESTONES_GROUPED_TASKS_TO_LINK,
				{
					milestoneId,
					projectId,
				},
			],
			queryFn: extractQueryParams(getPortalMilestonesGroupedTasksToLink),
			enabled: [!!projectId],
			allowedRoles: [EUserRoles.portalProjectAdministrator, EUserRoles.portalProjectMember],
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
			refetchOnMount: true,
			staleTime: 0,
		},
	);

	return {
		isLoadingPortalMilestonesGroupedTasksToLink: isInitialLoading,
		portalMilestonesGroupedTasksToLink: data || [],
	};
};
